
<div [style.backgroundImage]="'url(' + imageUrl + ')'" class="preview"></div>
<a mat-icon-button href="{{imageUrl}}" target="_blank"><mat-icon>open_in_new</mat-icon></a>
